import { createFileRoute, Link } from "@tanstack/react-router";
import { Mail, ArrowRight, Zap, BarChart3 } from "lucide-react";

export const Route = createFileRoute("/dashboard/admin/comms-email")({
  head: () => ({ meta: [{ title: "Email · Admin" }, { name: "robots", content: "noindex" }] }),
  component: EmailHub,
});

function EmailHub() {
  return (
    <div className="px-6 py-5 space-y-5">
      <div className="flex items-center gap-2">
        <Mail className="h-4 w-4 text-muted-foreground" />
        <h2 className="text-[18px] font-semibold tracking-tight font-display">Email</h2>
      </div>
      <p className="text-[13px] text-muted-foreground -mt-2">
        Outbound email, automated sequences, delivery, bounces, and engagement.
      </p>

      <div className="grid gap-3 md:grid-cols-2">
        <Link
          to="/dashboard/admin/comms/email-automations/upgrade"
          className="group card-surface-flat hover-lift rounded-md border border-border bg-card p-5 hover:border-primary/40 transition-colors"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-2">
              <Zap className="h-4 w-4 text-primary" />
              <h3 className="text-[14px] font-semibold font-display">Provider Upgrade Sequence</h3>
            </div>
            <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors" />
          </div>
          <p className="text-[12.5px] text-muted-foreground mt-2">
            7-step automated drip for providers who claimed a free profile but
            have not upgraded to Premium. Edit copy, send tests, monitor
            enrollments and conversions.
          </p>
        </Link>

        <Link
          to="/dashboard/admin/comms/email-automations"
          className="group card-surface-flat hover-lift rounded-md border border-border bg-card p-5 hover:border-primary/40 transition-colors"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-primary" />
              <h3 className="text-[14px] font-semibold font-display">All Email Automations</h3>
            </div>
            <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors" />
          </div>
          <p className="text-[12.5px] text-muted-foreground mt-2">
            Overview of every active automated email sequence, with live KPIs
            and quick links into each one.
          </p>
        </Link>
        <Link
          to="/dashboard/admin/comms/smartlead"
          className="group card-surface-flat hover-lift rounded-md border border-border bg-card p-5 hover:border-primary/40 transition-colors"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-2">
              <BarChart3 className="h-4 w-4 text-primary" />
              <h3 className="text-[14px] font-semibold font-display">Smartlead Analytics</h3>
            </div>
            <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors" />
          </div>
          <p className="text-[12.5px] text-muted-foreground mt-2">
            Live email outreach KPIs from Smartlead — emails sent, open rate,
            reply rate, bounces, and per-campaign breakdown.
          </p>
        </Link>
      </div>

      <div className="rounded-md border border-dashed border-border bg-muted/30 p-5">
        <p className="text-[12.5px] text-muted-foreground">
          One-off broadcast campaigns and full send-history analytics will appear
          here. For now, all programmatic emails are managed through Automations.
        </p>
      </div>
    </div>
  );
}
